import Vue from 'vue';
import Vuex from 'vuex';
import {login,getUserInfo} from '../api/man';

Vue.use(Vuex)
const state = { //设置全局访问的state对象
    project:'cloud classroom admin',
    userInfo:{
        userName:"guest",
        userRole:"student"
    },
    videoInfo:{

    },
    courseInfo:{

    },
    lecturerInfo:{

    }
}
const mutations = {

    changeUserInfo(state,payload){
        state.userInfo = payload;
    },
    changeVideoInfo(state,payload){
        state.videoInfo = payload;
    },
    changeCourseInfo(state,payload){
        state.courseInfo = payload;
    },
    changeLecturerInfo(state,payload){
        state.lecturerInfo = payload;
    }

}
const getters = {
    //todo 待后端权限设置
    getPrivilege:(state)=>(val)=>{
        switch(state.userInfo.userRole){
            case "student":
                return "/login";
            case "teacher":
                return "/logout"
            default:
                return "";
        }
    }
}
/**
 * async mutations
 */
const actions = {
    changeUserInfoAsync(context,payload){
        let userName = context.state.userInfo.userName;
        setTimeout(() => {
            context.commit("changeUserInfo",payload);
        }, 1000);
    },
    async refreshUserInfo({commit}){
		try{
			const res = await getUserInfo()
			if (res.status == 1) {
				commit('userInfo', res.data);
			}else{
				throw new Error(res.type)
			}
		}catch(err){
			console.log(err.message)
		}
	}
}
const store = new Vuex.Store({
    state,
    mutations,
    getters,
    actions
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js